import { render, staticRenderFns } from "./Autosuggest.vue?vue&type=template&id=72a57e20&scoped=true&"
import script from "./Autosuggest.vue?vue&type=script&lang=js&"
export * from "./Autosuggest.vue?vue&type=script&lang=js&"
import style0 from "./Autosuggest.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Autosuggest.vue?vue&type=style&index=1&id=72a57e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a57e20",
  null
  
)

export default component.exports